import React, { Fragment } from 'react'
import { Intro, Slideshow, slideTextTypes, slideTypes } from 'cvs-core'
import img1 from '../../assets/images/U1-T1-12a_L.svg'
import img2 from '../../assets/images/U1-T1-12b_R.svg'
import img3 from '../../assets/images/U1-T1-12c_L.svg'
import img4 from '../../assets/images/U1-T1-12d_L.svg'
import voAudio1 from '../../assets/vo/Wrap-up-01.mp3'
import voAudio2 from '../../assets/vo/Wrap-up-02.mp3'
import voAudio3 from '../../assets/vo/Wrap-up-03.mp3'
import voAudio4 from '../../assets/vo/Wrap-up-04.mp3'

const data = [
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 12.25,
    panDirection: 'left',
    image: img1,
    imageAltText: 'Is vaping safe?',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Is vaping safe?',
    },
    vo: {
      sources: [
        {
          src: voAudio1,
        },
      ],
      transcript:
        'E-cigarettes contain highly addictive nicotine and can cause permanent brain damage and affect memory, concentration, and decision making—especially in teens.',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 9.3,
    panDirection: 'right',
    image: img2,
    imageAltText: 'Delivers Toxins',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Delivers Toxins',
    },
    vo: {
      sources: [
        {
          src: voAudio2,
        },
      ],
      transcript:
        'When vaping/using e-cigarettes, a person is actually inhaling an aerosol and not water vapor, which delivers toxins to the body.',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 16,
    panDirection: 'left',
    image: img3,
    imageAltText: 'Social Consequences',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Social Consequences',
    },
    vo: {
      sources: [
        {
          src: voAudio3,
        },
      ],
      transcript:
        'There are also many social consequences that can result from vaping/using e-cigarettes such as losing friends, getting kicked off a team, being asked to leave a club, losing the trust of adults, detention, and legal problems.',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 11,
    panDirection: 'left',
    image: img4,
    imageAltText: 'Responding to Peer Pressure',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Responding to Peer Pressure',
    },
    vo: {
      sources: [
        {
          src: voAudio4,
        },
      ],
      transcript:
        'You can communicate your choice to not vape with strategies like direct refusal, exit strategies, providing information, and relying on human resources.',
    },
  },
]

export default {
  title: 'Using e-Cigarettes',
  path: '/wrap-up/using-e-cigarettes',
  content: (
    <Fragment>
      <Intro
        title="Using e-Cigarettes"
        direction="Select the play button below to begin."
      />
      <Slideshow slides={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Wrap-Up/UsingECigarettes.js